// src/components/XeokitViewer.jsx
import { useEffect, useRef } from "react";
// Core Viewer
import { Viewer } from "@xeokit/xeokit-sdk/src/viewer/Viewer.js";

// Loader for .xkt files
import { XKTLoaderPlugin } from "@xeokit/xeokit-sdk/src/plugins/XKTLoaderPlugin/XKTLoaderPlugin.js";

// Camera control and nav cube
import { CameraControl } from "@xeokit/xeokit-sdk/src/viewer/scene/CameraControl/CameraControl.js";
import { NavCubePlugin } from "@xeokit/xeokit-sdk/src/plugins/NavCubePlugin/NavCubePlugin.js"


export default function XeokitViewer({ src }) {
  const canvasRef = useRef(null);
  const navCubeRef = useRef(null);

  useEffect(() => {
    if (!canvasRef.current) return;

    const viewer = new Viewer({
      canvasId: canvasRef.current.id,
      transparent: true,
    });

    const cameraControl = new CameraControl(viewer.scene.camera, {
      doublePickFlyTo: true,
    });

    const navCube = new NavCubePlugin(viewer.scene, {
      canvasId: navCubeRef.current.id,
    });

    const xktLoader = new XKTLoaderPlugin(viewer);

    xktLoader
      .load({
        id: "myModel",
        src,
      })
      .then(() => {
        viewer.cameraFlight.flyTo(viewer.scene);
      })
      .catch((err) => console.error("Failed to load XKT:", err));

    return () => {
      viewer.destroy();
    };
  }, [src]);

  return (
    <div style={{ position: "relative", width: "100%", height: "100vh" }}>
      <canvas
        ref={canvasRef}
        id="xeokitCanvas"
        style={{
          width: "100%",
          height: "100%",
          display: "block",
          background: "#222",
        }}
      />
      <canvas
        ref={navCubeRef}
        id="navCubeCanvas"
        width="200"
        height="200"
        style={{
          position: "absolute",
          bottom: "20px",
          right: "20px",
          borderRadius: "8px",
        }}
      />
    </div>
  );
}



